import {Copmany, Interface} from '../types/edi';

export function deserialize({Form}): Array<Interface> {
    const interfaces = Form[0]?.MailInterfaces?.[0].Interface.map(item => {
        const {interfid, Companies} = item;

        const companies = Companies[0].Company.map(company => {
            return {
                isSelected: true,
                label: company.compdes,
                value: company.compid,
                interfid: interfid
            };
        });

        return {
            interfid,
            companies
        };
    });

    return interfaces || [];
}

export function serialize(interfaces: Array<Interface>, selected: Array<Copmany>) {
    const tables = [];

    interfaces.forEach((interf: Interface) => {
        const companies = getInterfaceSelectedCompanies(interf, selected);
        if (companies.length) {
            tables.push({
                tableName: 'Interface',
                rows: [
                    {
                        interfid: interf.interfid,
                        tables: [
                            {
                                tableName: 'Companies',
                                rows: [
                                    {
                                        tables: companies.map((company: Copmany) => {
                                            return {
                                                tableName: 'Company',
                                                rows: [{compid: company.value}]
                                            };
                                        })
                                    }
                                ]
                            }
                        ]
                    }
                ]
            });
        }
    });

    return {
        tables
    };
}

function getInterfaceSelectedCompanies(interf: Interface, companies: Array<Copmany>) {
    const list = [];

    companies.forEach((company: Copmany) => {
        interf.companies.forEach(comp => {
            if (comp.label === company.label) {
                list.push(comp);
            }
        });
    });

    return list;
}
